import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function CommonStyles() {
  return (
    <style jsx>{`
      .container {
        max-width: 960px;
        margin: 0 auto;
        padding: 20px;
        line-height: 1.5;
        font-size: 15px;
        font-family: "FreeSans", sans-serif;
        color: #222;
      }

      header h1 {
        font-size: 2.5rem;
        margin-bottom: 20px;
        font-weight: 700;
      }

      .text p {
        margin-bottom: 1em;
        font-size: 0.95rem;
        color: #333;
      }

      h2 {
        margin-top: 2.5em;
        font-size: 1.8rem;
        font-weight: 600;
      }

      .lang-switch {
        position: absolute;
        top: 20px;
        right: 20px;
      }

      .lang-switch button {
        background: #000;
        color: #fff;
        padding: 6px 14px;
        border-radius: 8px;
        border: none;
        cursor: pointer;
      }

      .grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
        gap: 16px;
        margin-top: 32px;
      }

      figure {
        margin: 0;
        overflow: hidden;
        border-radius: 6px;
        background: #f5f5f5;
      }

      img {
        width: 100%;
        height: auto;
        display: block;
        transition: transform 0.3s ease;
      }

      img:hover {
        transform: scale(1.03);
      }

      figcaption {
        padding: 8px 10px;
        font-size: 0.85rem;
        color: #555;
      }

.back-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.back-button button {
  background: #000;
  color: #fff;
  padding: 5px 12px;        /* kleiner */
  border-radius: 6px;       /* etwas dezenter */
  font-size: 0.8rem;        /* kleiner */
  border: none;
  cursor: pointer;
  transition: opacity 0.25s ease;
}

.back-button button:hover {
  opacity: 0.8;
}

.lang-switch {
  position: absolute;
  top: 20px;
  right: 20px;
}

.lang-switch button {
  background: #000;
  color: #fff;
  padding: 5px 12px;        /* identisch */
  border-radius: 6px;       /* identisch */
  font-size: 0.8rem;        /* identisch */
  border: none;
  cursor: pointer;
  transition: opacity 0.25s ease;
}

.lang-switch button:hover {
  opacity: 0.8;
}

      @media (max-width: 600px) {
        .container {
          padding: 16px;
          font-size: 14px;
        }

        .text p {
          font-size: 0.8rem;
        }

        header h1 {
          font-size: 1.8rem;
        }

        h2 {
          font-size: 1.4rem;
        }

        .grid {
          grid-template-columns: 1fr;
        }
      }
    `}</style>
  );
}

export default function Zeitlinien() {
  const [images, setImages] = useState([]);

useEffect(() => {
  const fetchImages = async () => {
    try {
      const res = await fetch("/data/timelines.json", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-store, no-cache, must-revalidate, max-age=0",
          "Pragma": "no-cache"
        }
      });

      if (!res.ok) {
        throw new Error("Fehler beim Laden von timelines.json");
      }

      const json = await res.json();
      setImages(json.images || []);
    } catch (err) {
      console.error(err);
    }
  };

  fetchImages();
}, []);

  return (
    <article className="container">
      <div className="lang-switch">
        <Link to="/Timelines">
          <button>EN</button>
        </Link>
      </div>

      <header>
        <h1>Zeitlinien</h1>
      </header>

      <section className="text">
        <p>
          Im Zentrum der künstlerischen Praxis von<Link to="/ArchivDe">  Billi Thanner</Link> steht die Linie als elementare Struktur des Raums.
          Nicht als grafisches Zeichen, sondern als physische, zeitbasierte Ebene.
        </p>

        <p>
          Ihre Lichtskulpturen und Installationen untersuchen Wahrnehmung als aktiven Prozess.
          Raum erscheint dabei nicht als statische Gegebenheit, sondern als relationales Feld – 
          als Gefüge aus Bewegung, Energie, Beobachtung und Zwischenräumen.
        </p>

        <p>
          In Analogie zu zeitgenössischen Feldtheorien versteht Thanner Realität als dynamisch.
          Die Linie fungiert als temporale Spur: Sie markiert Übergänge, Verdichtungen und Überlagerungen.
          Architektur wird nicht ergänzt, sondern in ein Ereignis überführt.
        </p>

        <p>
          Licht wird zum Medium der Sichtbarmachung. Urbane Ströme, Frequenzen und Bewegungen –
          Prozesse, die gewöhnlich unsichtbar bleiben – manifestieren sich als lineare Energiefelder.
          Wie ein Speicher der Zeit, als räumliches <Link to="/ArchivDe"> Gedächtnisarchiv</Link> , beschreibt Thanner diese Dimension ihrer Arbeit.
        </p>

        <p>Die Linie erscheint dabei nicht als Grenze, sondern als Schwelle.</p>
        <p>Nicht als Abschluss, sondern als Durchgang.</p>

        <p>
          Thanners Werk operiert im Spannungsfeld zwischen Ordnung und Fluss.
          Struktur wird nicht aufgelöst, sondern in Schwingung versetzt.
          Die Linie wird zum Informationsträger – zu einem Code zwischen Ort und Betrachter.
        </p>

        <p><strong>Ihre zentrale Fragestellung lautet:</strong></p>
        <p>
          Was wird sichtbar, wenn wir die technischen Mittel entwickeln,
          unsere eigenen Spuren im Raum wahrzunehmen?
        </p>

        <p>
          In dieser Praxis entsteht Skulptur nicht als Objekt,
          sondern als Zustand – als temporäre Konstellation zwischen Licht,
          Architektur, Wahrnehmung und Zwischenraum.
        </p>

        <h2>Vertikale Frequenz</h2>

        <p>
          <strong>Serie Zeitlinien, 2026</strong><br />
          Einzelne Objekte je 30 × 33 cm (16 Stück)<br />
          Zentralobjekt: 65 × 71 cm
        </p>

        <p>
          In Vertikale Frequenz wird die Linie in modulare Lichteinheiten überführt.
          Mehrere vertikal ausgerichtete Lichtkörper bilden ein serielles Feld,
          das Rhythmus, Puls und Intensität erzeugt.
        </p>

        <p>
          Jedes Modul fungiert als eigenständiger Impuls und zugleich als Teil
          einer übergeordneten Struktur. Durch Wiederholung und minimale Variation
          entsteht ein energetisches Raster, das den Raum nicht füllt, sondern strukturiert.
        </p>

        <p>
          Die vertikale Ausrichtung verdichtet Bewegung zur Aufrichtung.
          Licht wird hier zur messbaren Präsenz – als Frequenz,
          die zwischen Stabilität und Schwingung oszilliert.
        </p>

        <p>
          Vertikale Frequenz versteht Skulptur als System:
          als Konstellation von Licht, Architektur und Wahrnehmung,
          die sich mit jeder Position des Betrachters neu organisiert.
        </p>
      </section>

      <section className="gallery">
        <div className="grid">
          {images.map((img, i) => (
            <figure key={i}>
              <img src={img.url} alt={img.alt || ""} loading="lazy" />
              {img.title && <figcaption>{img.title}</figcaption>}
            </figure>
          ))}
        </div>
      </section>

      <div className="back-button">
        <Link to="/">
          <button>zurück</button>
        </Link>
      </div>

      <CommonStyles />
    </article>
  );
}